import React from 'react'

const SubscriptionMessage = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
)

export default SubscriptionMessage
